import React from 'react';
import Button from '../Button/Button';
import './ValidationPopUp.css';

interface ValidationPopUpProps {
  title: string;
  text: string;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  cancelLabel?: string;
  confirmLabel?: string;
  children?: React.ReactNode; // Ajout de la prop children pour le contenu personnalisé
  isLoading?: boolean; // Pour désactiver les boutons pendant un chargement
}

const ValidationPopUp: React.FC<ValidationPopUpProps> = ({
  isOpen,
  title,
  text,
  onClose,
  onConfirm,
  cancelLabel,
  confirmLabel,
  children, // Ajout du support pour les enfants
  isLoading = false
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>{title}</h2>
        <p className="modal-text">{text}</p>

        {/* Afficher le contenu personnalisé s'il existe */}
        {children && <div className="modal-custom-content">{children}</div>}

        <div className="modal-actions">
          {cancelLabel && (
            <Button
              value={cancelLabel}
              variant="secondary"
              onClick={onClose}
              disabled={isLoading}
            />
          )}
          {confirmLabel && (
            <Button
              value={isLoading ? 'Chargement...' : confirmLabel}
              variant="primary"
              onClick={onConfirm}
              disabled={isLoading}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ValidationPopUp;